import { createStore } from 'effector';

const initFilters = {
  gradient: [],
  draw_polygon: [],
};

export const $activeFilters = createStore(initFilters);
$activeFilters.watch((state) => console.log('$activeFilters', state));
